<div class="modal-header">
    <div class="d-flex">
        <h6 class="flex-fill">{{ data.MasterContactId }}</h6>
        <button type="button" class="modal-close icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="closeModal()">
            <svg class="icon-16">
                <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
            </svg>
        </button>
    </div>
</div>
<div class="modal-body">
    <div class="font-weight-bold mb-2" cvLocalizedText langSection="Linked_Contacts" langKey="Contact_Details">Contact Details</div>
    <div class="container font-weight-bold">
        <div class="row">
            <div class="col">
                <span cvLocalizedText langSection="Linked_Contacts" langKey="Media">Media</span>
                <span>:</span>
                <span class="ml-1 font-weight-normal">{{ data.Media }}</span>
            </div>
            <div class="col">
                <span cvLocalizedText langSection="Linked_Contacts" langKey="ANI">ANI</span>
                <span>:</span>
                <span class="ml-1 font-weight-normal">{{ data.CustomerNumber }}</span>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <span cvLocalizedText langSection="Linked_Contacts" langKey="Contact_End_Reason">Contact End Reason</span>
                <span>:</span>
                <span class="ml-1 font-weight-normal">{{ data.ContactEndReason }}</span>
            </div>
            <div class="col">
                <span cvLocalizedText langSection="Linked_Contacts" langKey="Start_Time">Start Time</span>
                <span>:</span>
                <span class="ml-1 font-weight-normal">{{ data.StartDate | date: CVMomentDateTimeWithSecondsFormat }}</span>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <span cvLocalizedText langSection="Linked_Contacts" langKey="Master_Contact_Id">Master Contact ID</span>
                <span>:</span>
                <span class="ml-1 font-weight-normal">{{ data.MasterContactId }}</span>
            </div>
            <div class="col">
                <span cvLocalizedText langSection="Linked_Contacts" langKey="Duration">Total Duration</span>
                <span>:</span>
                <span class="ml-1 font-weight-normal">{{ formatSecondsToTime(data.TotalDurationInSeconds) }}</span>
            </div>
        </div>
    </div>

    <div style="min-height: 300px; max-height: 550px; overflow-y: auto;" class="mt-4">
        <ag-grid-angular
            #linkedContactsDetailsGrid 
            *ngIf="gridOptions != null"
            class="ag-theme-balham flex-fill"
            [gridOptions]="gridOptions"
            style="width:100%; height: 400px;">
        </ag-grid-angular>
    </div>
</div>
